<template>
    <div class="invite_popup">
        <transition name="scale">
            <div class="invite_popup_con">
                <div class="main"
                     ref="content">
                    <img src="./img/share_posters.png"
                         class="big_img" />
                    <img :src="base64src"
                         class="code_img" />
                </div>
                <img src="./img/icon_img21.png"
                     @click="close"
                     class="close" />

                <div class="bottom_area">
                    <div class="btn flex ac"
                         @click="download"> <img src="./img/icon_img46.png"
                             class="down" /><span>下载图片</span></div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import html2canvas from 'html2canvas';
export default {
    data () {
        return {
            codesrc: 'https://www.gongwenzhijia.com/static/img/qywx_kf_logo_gwzj.png',
            base64src: ''
        }
    },
    created () {
        this.base64src = this.codesrc
        this.getBase64(this.codesrc).then(base64 => {
            this.base64src = base64
        }, err => {

        })
    },
    methods: {
        close () {
            this.$store.commit('setInviteCode', false)
        },
        //下载
        download () {
            const content = this.$refs.content; // 获取需要保存为图片的 DOM 元素
            html2canvas(content).then(canvas => {
                setTimeout(() => {
                    // 将 Canvas 转换为图片数据
                    const imageData = canvas.toDataURL('image/png');
                    // 创建一个 <a> 元素，并设置 href 属性为图片数据
                    const a = document.createElement('a');
                    a.href = imageData;
                    a.download = 'share_image.png'; // 设置下载文件名
                    a.click(); // 模拟点击下载

                }, 500)
            },);
        },
        getBase64 (img) {
            function getBase64Image (img, width, height) {
                //width、height调用时传入具体像素值，控制大小 ,不传则默认图像大小
                var canvas = document.createElement("canvas");
                canvas.width = width ? width : img.width;
                canvas.height = height ? height : img.height;

                var ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                var dataURL = canvas.toDataURL();
                return dataURL;
            }
            var image = new Image();
            image.crossOrigin = '';
            image.src = img;
            return new Promise((resolve, reject) => {
                image.onload = function () {
                    resolve(getBase64Image(image));//将base64传给done上传处理
                }
            });
        }

    }
}
</script>

<style lang="scss" scoped>
.invite_popup {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1501;
    bottom: 0;
    left: 0;
    transition: all 0.3s;
    background: rgba(0, 0, 0, 0.8);
    overflow: auto;
    animation: fadeInSlowAni 0.3s 1;
    .invite_popup_con {
        position: fixed;
        z-index: 1501;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: transform 0.2s;
        background-color: #1e1f22;
        border: 2px solid #5865f2;
        border-radius: 6px;
        height: 90vh;
        overflow-y: auto;
        padding-bottom: 80px;
        &::-webkit-scrollbar {
            display: none !important;
            width: 0 !important;
        }

        &::-webkit-scrollbar-thumb {
            height: 0px !important;
        }
        .main {
            widows: 100%;
            height: 100%;
        }
        .big_img {
            height: 100%;
        }
        .close {
            position: absolute;
            width: 20px;
            height: 20px;
            right: 15px;
            top: 15px;
            z-index: 9;
            cursor: pointer;
            opacity: 0.8;
        }
        .code_img {
            width: 50%;
            position: absolute;
            left: 50%;
            top: 35%;
            transform: translateX(-50%);
        }
        .bottom_area {
            position: absolute;
            width: 100%;
            height: 80px;
            bottom: 0;
            right: 0;
            left: 0;
            background-color: #1e1f22;
            .btn {
                border: 3px solid #5865f2;
                width: 120px;
                height: 40px;
                margin: 20px auto;
                border-radius: 40px;
                justify-content: center;
                line-height: 36px;
                padding: 0 10px;
                cursor: pointer;
                &:hover {
                    opacity: 0.7;
                }
                img {
                    width: 16px;
                    height: 16px;
                    margin-right: 10px;
                }
                span {
                    font-size: 14px;
                    color: #fff;
                }
            }
        }
    }
}
</style>